import { BiTableDensity, kBiVizStyleOptionNames } from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChip } from '../../../../components/ui/BiChip';
import { StyleGroup } from '../StyleGroup';
import { StyleRow } from '../StyleRow';
import { biPatchedOption, biWithStyleOption } from '../functions/biStyleEdit';
import { BiStyleOptionProps } from '../functions/biStyleOptionProps';

/** The table's density, zebra rows and totals; a chart's table view too. */
export const TableOptions = memo(({ style, onChange }: BiStyleOptionProps) => {
  const table = biPatchedOption(style, 'table', {});
  const set = (patch: Partial<typeof table>) =>
    onChange(
      biWithStyleOption(style, 'table', biPatchedOption(style, 'table', patch)),
    );
  return (
    <StyleGroup
      title={kBiVizStyleOptionNames.table}
      onReset={
        style?.table
          ? () => onChange(biWithStyleOption(style, 'table', undefined))
          : null
      }
    >
      <StyleRow label="行距">
        <BiChip
          label="紧凑"
          selected={table.density === BiTableDensity.Compact}
          onPress={() => set({ density: BiTableDensity.Compact })}
        />
        <BiChip
          label="标准"
          selected={table.density === BiTableDensity.Normal}
          onPress={() => set({ density: BiTableDensity.Normal })}
        />
      </StyleRow>
      <StyleRow label="样式">
        <BiChip
          label="斑马纹"
          selected={table.zebra}
          onPress={() => set({ zebra: !table.zebra })}
        />
        <BiChip
          label="合计行"
          selected={table.totalsRow}
          onPress={() => set({ totalsRow: !table.totalsRow })}
        />
      </StyleRow>
    </StyleGroup>
  );
});
